import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';

/**
 * Homepage class.
 */
export default class MenuItem extends Base {
  isOpen = false;
  breakpoints = ['xxs', 'xs', 's', 'm'];
  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'MenuItem',
    refs: ['close', 'submenu', 'items[]', 'back'],
    emits: ['open', 'close'],
  };

  /**
   *
   */
  mounted() {
    this.initTimeline();
  }

  /**
   *
   */
  initTimeline() {
    this.tl = gsap.timeline({ paused: true });
    this.tl.fromTo(
      this.$refs.submenu,
      {
        'clip-path': this.isMobile ? 'inset(0 0 0 0)' : 'inset(0% 0% 100% 0%)',
        xPercent: this.isMobile ? 100 : 0,
      },
      {
        'clip-path': 'inset(0% 0% 0% 0%)',
        xPercent: 0,
        duration: 0.5,
        ease: 'power4.out',
      },
    );

    this.tl.fromTo(
      this.$refs.items,
      {
        opacity: 0,
        y: -10,
      },
      {
        stagger: {
          each: 0.08,
        },
        ease: 'power4.out',
        opacity: 1,
        duration: 0.8,
        y: 0,
      },
      '-=0.3',
    );
    gsap.set(this.$refs.submenu, { display: 'block' });
  }

  /**
   *
   */
  onMouseenter() {
    if (this.isMobile) return;
    this.openSubmenu();
  }

  /**
   *
   */
  onMouseleave() {
    if (this.isMobile) return;
    this.closeSubmenu();
  }

  /**
   * Click on mobile on parent item
   * @param {object} props
   * @param {Event} props.event
   */
  onClick({ event }) {
    if (this.isMobile && !this.isOpen) {
      event.preventDefault();
      this.openSubmenu();
    }
  }

  /**
   * Close submenu
   * @param {object} props
   * @param {Event} props.event
   */
  onBackClick({ event }) {
    event.preventDefault();
    event.stopPropagation();
    this.closeSubmenu();
  }

  /**
   * Open menu nothing more
   * @returns {void}
   */
  openSubmenu() {
    if (this.isOpen) return;

    this.tl.play(0);

    this.$emit('open');
    this.isOpen = true;
  }

  /**
   * Close menu nothing more
   * @returns {void}
   */
  closeSubmenu() {
    if (!this.isMobile) {
      this.$emit('close');
    }
    this.tl.seek(0);
    gsap.fromTo(
      this.$refs.submenu,
      {
        'clip-path': 'inset(0% 0% 0% 0%)',
        xPercent: 0,
      },
      {
        'clip-path': this.isMobile ? 'inset(0% 0% 0% 0%)' : 'inset(100% 0% 0% 0%)',
        duration: 0.5,
        xPercent: this.isMobile ? 100 : 0,
        ease: 'power4.out',
      },
    );
    this.isOpen = false;
  }

  /**
   * Check if device is mobile
   * @returns {boolean}
   */
  get isMobile() {
    return this.breakpoints.includes(this.$services.get('resized').breakpoint);
  }
}
